import $ from 'jquery';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default class DynamicSlideshow {
  constructor(section) {
    this.$el = $(section.el);
    this.data = section.data;
    this.$slideshow = $('[data-slideshow]', this.$el);
    this.$slides = $('[data-slideshow-slide]', this.$el);
    this.autoplay = this.data.should_autoplay
      && this.data.autoplay
      ? this.data.autoplay * 1000
      : false;

    if (this.data.slide_count > 1) {
      this._initFlickity();
      this._bindEvents();
    }
  }

  _initFlickity() {
    this.flickity = new Flickity(this.$slideshow[0], {
      accessibility: true,
      adaptiveHeight: true,
      autoPlay: this.autoplay,
      cellAlign: 'left',
      cellSelector: '[data-slideshow-slide]',
      friction: 0.8,
      imagesLoaded: true,
      pageDots: false,
      pauseAutoPlayOnHover: true,
      prevNextButtons: true,
      selectedAttraction: 0.2,
      wrapAround: true,
    });
  }

  _bindEvents() {
    this.$slides.on('focusin.slideshow', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const slideIndex = this.$slides.index($(event.currentTarget));
      this.flickity.select(slideIndex, false, true);
      this.flickity.reloadCells();
    });
  }

  _unbindEvents() {
    this.$slides.off('focusin.slideshow');
  }

  onSectionBlockSelect(block) {
    const $slides = $('[data-slideshow-slide]', this.$el);
    const slideIndex = $slides.index($(block.el));

    this.flickity.select(slideIndex, false, false);

    if (this.autoplay) {
      this.flickity.stopPlayer();
    }
  }

  onSectionBlockDeselect() {
    if (this.autoplay) {
      this.flickity.playPlayer();
    }
  }

  onSectionUnload() {
    this.flickity.destroy();
    this._unbindEvents();
  }
}
